import { ENGLISH_LANGUAGES_SORTED, TRANSLATION_LANGUAGES_LOCALIZED } from '../translations/index.mjs';
"use strict";
const getLanguageLabel = lang => {
  const englishName = ENGLISH_LANGUAGES_SORTED[lang];
  const localizedName = TRANSLATION_LANGUAGES_LOCALIZED[lang];
  return `${englishName} (${localizedName})`;
};
export { getLanguageLabel };
//# sourceMappingURL=getLanguageLabel.mjs.map
